"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonSearchFilter = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const OktonSearchFilter = ({ value, onChange, placeholder = 'Buscar...', minWidth = 260, maxWidth = 460, isDisabled, }) => {
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    const color = (0, react_1.useColorModeValue)('#3f3f46', '#d4d4d8');
    const width = Math.min(maxWidth, Math.max(minWidth, placeholder.length * 7 + 76));
    return (react_2.default.createElement(react_1.Flex, { borderWidth: "1px", p: "2", rounded: "2xl", bg: bg, align: "center", w: width + 16 + 'px' },
        react_2.default.createElement(react_1.InputGroup, { w: "100%" },
            react_2.default.createElement(react_1.InputLeftElement, { pointerEvents: "none", color: "gray.400" }, react_2.default.createElement(lu_1.LuSearch, { size: 16 })),
            react_2.default.createElement(react_1.Input, { name: "busca", color: color, borderWidth: "2px", placeholder: placeholder, value: value, isDisabled: isDisabled, onChange: event => onChange(event.target.value) }),
            value !== '' ? (react_2.default.createElement(react_1.InputRightElement, null,
                react_2.default.createElement(react_1.IconButton, { "aria-label": "Limpar busca", size: "xs", variant: "ghost", icon: react_2.default.createElement(lu_1.LuX, { size: 14 }), onClick: () => onChange(''), isDisabled: isDisabled }))) : null)));
};
exports.OktonSearchFilter = OktonSearchFilter;
//# sourceMappingURL=SearchFilter.js.map